<template>
  <div>
    <v-list class="bg-transparent !flex flex-col items-center ">
      <ProfileFilter :dialog="filterDialog" @close-dialog="filterDialog = false" />
      <v-list-item v-for="(item, i) in navItem" :key="item.name" class="mb-2" v-motion :initial="{
        x: 100,
        opacity: 0,
      }" :enter="{
  x: 0,
  opacity: 1,
  transition: {
    duration: 300,
    type: 'keyframes',
    ease: 'backOut',
    delay: `${i}00`,
  },
}">
        <NavButton :iconName="item.iconName" :name="item.name" :link="item.link" :badge="item.badge"
          @callFunction="fn_handle(item.click)" :badgeContent="item.badgeContent" />
      </v-list-item>
      <!-- <v-list-item>
        <NavButton iconName="ph:magnifying-glass-light" name="Filter" badge
          @callFunction="filterDialogToggle" />
      </v-list-item> -->

      <!-- <v-list-item dense class="mb-2">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab dark x-large :to="{ name: 'Profiles', params: { type: routeLink } }" v-bind="attrs" v-on="on">
              <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/home.png`)" alt />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Home</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2" v-if="!premium">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-badge v-if="!premium" overlap left bordered icon="mdi-crown-outline" :color="colorAsRoute" avatar dark
              color="black" :class="`font-Nunito ${routeLink}_text_color`" offset-x="20" offset-y="20">
              <v-btn dark fab x-large @click.prevent="filterDialogToggle" icon v-bind="attrs" v-on="on">
                <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/search.png`)" alt />
              </v-btn>
            </v-badge>
            <v-btn dark fab x-large @click.prevent="dialog = true" icon >
              <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/search.png`)" alt />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Filter For Premium Users </span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2" v-show="premium">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">

            <v-btn dark fab x-large @click.prevent="filterDialogToggle" icon v-bind="attrs" v-on="on">
              <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/search.png`)" alt />
            </v-btn>

            <v-btn dark fab x-large @click.prevent="dialog = true" icon >
              <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/search.png`)" alt />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Filter </span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-badge overlap left :content="messages.length" :value="messages.length" color="black"
              :class="`font-Nunito ${routeLink}_text_color`" offset-x="20" offset-y="20">
              <v-btn fab x-large dark v-bind="attrs" v-on="on"
                :to="{ name: 'Notifications', params: { type: routeLink } }">
                <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/ring.png`)" alt />
              </v-btn>
            </v-badge>
          </template>
          <span :class="`${routeLink}_text_color`">Notifications</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-badge overlap left :content="getUnreadMessageAll" :value="getUnreadMessageAll" color="black"
              :class="`font-Nunito ${routeLink}_text_color`" offset-x="20" offset-y="20">
              <v-btn fab dark x-large :to="{ name: 'Chats', params: { type: routeLink } }" v-bind="attrs" v-on="on">
                <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/comment.png`)" alt />
              </v-btn>
            </v-badge>
          </template>
          <span :class="`${routeLink}_text_color`">Chats</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab dark x-large @click.prevent="$store.dispatch('changePom', true)" v-bind="attrs" v-on="on">
              <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/dollar.png`)" alt />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Profile of the Month</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab dark x-large :to="{ name: 'Settings', params: { type: routeLink } }" v-bind="attrs" v-on="on">
              <v-img max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/setting.png`)" alt />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Settings</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item class="mb-2">
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-btn fab x-large @click.prevent="logOutUser" v-bind="attrs" v-on="on">
              <v-img class="rounded-full" max-width="80"
                :src="require(`@/assets/img/nav-icons/${routeLink}/logout.png`)" alt="" />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Logout</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item>
        <v-tooltip left dark color="black">
          <template v-slot:activator="{ on, attrs }">
            <v-btn x-large fab @click.prevent="" v-bind="attrs" v-on="on">
              <v-img class="rounded-full" max-width="80" :src="require(`@/assets/img/nav-icons/${routeLink}/lock.png`)"
                alt="" />
            </v-btn>
          </template>
          <span :class="`${routeLink}_text_color`">Lock Your Screen</span>
        </v-tooltip>
      </v-list-item> -->
    </v-list>
    <!-- <v-dialog v-model="premiumDialog" v-show="premiumDialog" dark persistent max-width="400">
      <v-card class="!bg-black pb-2 !border-0 !rounded-tr-2xl !rounded-bl-2xl">
        <v-card-title :class="`${routeLink}_fortext`" class="text-3xl  !break-normal text-center !block !font-Handel">
          Only for
          <span class="font-weight-bold"> Premium Members, </span> Subscribe Now
          for Premium Package
        </v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="white--text font-Handel" small text @click="premiumDialog = false">
            Cancel
          </v-btn>

          <v-btn class="font-Handel " :class="`${routeLink}_color`" small @click="setUserProfile">
            Subscribe Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <SubscribePremiumDialog />
  </div>
</template>

<script>
import NavButton from "../NavButton.vue";
import SubscribePremiumDialog from "../settings/SubscribePremiumDialog.vue";
import ProfileFilter from "./ProfileFilter.vue";
import { CometChat } from "@cometchat-pro/chat";
import axios from "axios";


export default {
  name: "Nav",
  components: {
    ProfileFilter,
    NavButton,
    SubscribePremiumDialog
},
  data() {
    return {
      messages: [],
      filterDialog: false,
      premiumDialog: false,
      allUnreadMessages: '',
      navItem: [
        {
          name: "Home",
          link: { name: 'Profiles', params: { type: this.$route.params.type } },
          iconName: 'system-uicons:home-alt',
          badge: false,
          click: ''
        },
        {
          name: "Search",
          link: {},
          iconName: 'ph:magnifying-glass-light',
          badge: true,
          click: 'filterDialogToggle',
        },
        {
          name: "Notifications",
          link: { name: 'Notifications', params: { type: this.$route.params.type } },
          iconName: 'ph:bell-ringing-light',
          badge: true,
          badgeContent: 'notification',
          click: 'clearNotifications',
        },
        {
          name: "Chats",
          link: { name: 'Chats', params: { type: this.$route.params.type } },
          iconName: 'ph:chat-centered-dots-light',
          badge: true,
          badgeContent: 'message',
          click: '',
        },
        {
          name: "Profile of the Month",
          link: {},
          iconName: 'ph:trophy-light',
          badge: !this.$store.getters.isPremium,
          click: 'pomModal',
        },
        {
          name: "Settings",
          link: { name: 'SelectedSetting', params: { type: this.$route.params.type ,setting: 'PaymentDetails'} },
          iconName: 'clarity:settings-line',
          badge: false,
          click: '',
        },
        {
          name: "Logout",
          link: {},
          iconName: 'carbon:logout',
          badge: false,
          click: 'logOutUser',
        },
        {
          name: "Screen Lock",
          link: {},
          iconName: 'ph:lock-key-open-light',
          badge: false,
          click: 'screenLock',
        },
      ],
    };
  },
  computed: {
    // getUnreadMessageAll() {
    //   return this.navItem.forEach(i => {
    //     if (i.name == 'Chats' && i.badgeContent) {
    //       i.badgeContent = this.$store.getters.unreadMessages;
    //     }
    //     else{
    //       console.log('Not found')
    //     }
    //   })
    // },
    // getBadgeData() {
    //   this.navItem.forEach(i => {
    //     if (i.name == "Profile of the Month") {
    //       return true;
    //     } else if (i.name == "Search") {
    //       return true;
    //     }
    //     else if (i.name == "Notifications") {
    //       return true;
    //     }
    //     return false;
    //   })
    // },
    getUnreadNotification() {
      return this.$store.getters.unreadNotification;
    },
    getUnreadMessageAll() {
      return this.$store.getters.unreadMessages;
    },
    premium() {
      return this.$store.getters.isPremium;
    },
    colorAsRoute() {
      if (this.routeLink == 'straight') {
        return '#a07a1d'
      }
      else if (this.routeLink == 'gay') {
        return '#88c3fa'
      }
      else if (this.routeLink == 'lesbian') {
        return '#9e2eec'
      }
    }
  },
  methods: {
    fn_handle(fn_name) {
      if (fn_name) {
        this[fn_name]();
      }
    },
    getBadgeData() {
      this.navItem.forEach(i => {
        if (i.name == "Profile of the Month") {
          return i.badge = !this.$store.getters.isPremium;
        } else if (i.name == "Search") {
          return i.badge = !this.$store.getters.isPremium;
        }
        else if (i.name == "Notifications" || i.name == "Chats") {
          return i.badge = true;
        }
        return i.badge = false;
      })
    },
    screenLock() {
      this.$emit('lock-app')
    },
    pomModal() {
      this.$store.dispatch('changePom', true)
    },
    // clearNotifications() {
    //   this.navItem.forEach(i => {
    //     if (i.name == 'Notifications' && i.badgeContent) {
    //       i.badgeContent = 0;
    //     }
    //   })
    // },
    filterDialogToggle() {
      if (this.$store.getters.isPremium) {
        this.filterDialog = true;
      } else {
        this.openSubscribeToPremiumDialog()
      }
    },
    // async messagesHandler(data) {
    //   this.messages.push(JSON.stringify(data));
    //   const resp = await axios.get('user-notifications')

    //   const notif = resp.data.data.filter(i => i.read_at == null)

    //   this.navItem.forEach(i => {
    //     if (i.name == 'Notifications') {
    //       i.badgeContent = notif.length
    //     }
    //   })
    // },
    async logOutUser() {
      await this.$store.dispatch("LogOut");
    },
    setUserProfile() {
      this.premiumDialog = false,
        this.$store.dispatch("premium")
    },
  },
  created() {
    this.getBadgeData();

    this.$store.subscribe((mutation, state) => {
      if (mutation.type == 'changePremiumState') {
        this.getBadgeData()
      }
    })
  },
};
</script>

<style scoped>
.listAdjuster {
  background: transparent !important;
  position: absolute;
  right: 1%;
  top: 50%;
  transform: translate(0%, -50%);
}

.listAdjuster.v-list-item {
  height: 50px;
  width: 50px;
}

.v-image:deep(.v-responsive__content) {
  width: 100% !important;
}

.straight_text_color {

  color: #a07a1d !important;
}

.gay_text_color {
  color: #88c3fa !important;
}

.lesbian_text_color {
  color: #9e2eec !important;
}

.straight_text_color:deep(.v-badge__badge) {

  color: #a07a1d !important;
}

.gay_text_color:deep(.v-badge__badge) {
  color: #88c3fa !important;
}

.lesbian_text_color:deep(.v-badge__badge) {
  color: #9e2eec !important;
}

.Vue-Toastification__toast--default {
  background: #000 !important;
  color: #a07a1d !important;
}

.straight_color {
  /*background: linear-gradient(146deg, #dba83b, #d4b577 22%, #ae8935 30%, #a27c2b 70%, #d4b374 80%, #a87a2c);*/
  background: rgb(177, 145, 65);
  background: linear-gradient(345deg,
      rgb(97 69 0) 0%,
      rgba(202, 174, 112, 1) 53%,
      rgb(90 64 0 / 97%) 100%);
}

.lesbian_color {
  background: rgb(126, 0, 157);
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
}

.gay_color {
  background: rgb(0, 240, 255);
  background: linear-gradient(39deg,
      rgba(0, 240, 255, 1) 0%,
      rgba(0, 156, 255, 1) 100%);
}
</style>
